import { Toaster as Sonner, type ToasterProps } from 'sonner';

/** Toast-Container (frontend-ux.md: nie `alert()`, immer Toasts). */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: 'bg-card text-card-foreground border-border shadow-lg',
          description: 'text-muted-foreground',
          error: 'text-destructive',
        },
      }}
      {...props}
    />
  );
}
